/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useHomePath} from 'app/utils/homePath'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Header} from './Header'
import {Navbar} from './Navbar'

export function HeaderWrapper() {
  const {config, classes} = useLayout();
  const homePath = useHomePath();

  if (!config.app?.header?.display) {
    return null
  }

  return (
    <div id='kt_app_header' className='app-header'>
      <div
        id='kt_app_header_container'
        className={clsx(
          'app-container flex-grow-1',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
      >
        {config.app.sidebar?.display && (
          <>
            <div
              className='d-flex align-items-center ms-n2 me-2'
              title='Show sidebar menu'
            >
              <div
                className='btn btn-icon btn-active-color-primary w-35px h-35px'
                id='kt_app_sidebar_mobile_toggle'
              >
                <KTSVG path='/media/icons/duotune/abstract/abs015.svg' className=' svg-icon-1' />
              </div>
              <div className='d-flex align-items-center  flex-grow-0'>
                <Link to={homePath} className=''>
                  <img alt='Logo' src='./assets/media/logos/default-small.svg' className='h-30px' />
                </Link>
              </div>
            </div>
          </>
        )}

        {!config.app.sidebar?.display && (
          <div className='d-flex align-items-center flex-grow-0 me-md-10'>
            <Link to={homePath}>
              {/*{config.layoutType != 'dark-header' ? (
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('/media/logos/logo-default-black.png')}
                  className='h-30px h-lg-40px app-sidebar-logo-default'
                />
              ) : (*/}
                <>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/logo-dark.png')}
                    className='h-50px h-lg-50px app-sidebar-logo-default theme-light-show'
                  />
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/logo-light.png')}
                    className='h-50px h-lg-50px app-sidebar-logo-default theme-dark-show'
                  />
                </>

            </Link>
          </div>
        )}

        <div
          id='kt_app_header_wrapper'
          className='flex-root d-flex align-items-flex-end align-self-center flex-direction-column'
        >
          {config.app.header.default?.content === 'menu' &&
            config.app.header.default.menu?.display && (
              <div
                className='flex-root app-header-menu app-header-mobile-drawer align-items-stretch'
              >
                <Header />
              </div>
            )}
          <Navbar />
        </div>
      </div>
    </div>
  )
}
